<!--  -->
<template>
  <div class="text-tem">
      <tem-head :globalConfig='globalConfig' v-if="temData.title" :text="temData.title" />
      <Section :globalConfig='globalConfig' :hasBorder='temData.hasBorder' :text="temData.imageTextItemList[0].content" />
  </div>
</template>

<script>
import TemHead from '@/components/TemHead'
import Section from '@/components/Section'
import { mapState } from 'vuex'
export default {
  props: {
    temData: {
      type: Object
    }
  },
  computed: {
    ...mapState({
        globalConfig: state => state.router.globalConfig,
    }),
  },
  components: {
    TemHead,
    Section
  },

}

</script>
<style lang='less' scoped>
.text-tem {
  overflow: hidden;
}
</style>